import React from "react";
import { View } from "react-native";
import Theme from "../argon-ui/Theme";
import { translate } from "../locales/translate";
import InputBase from "../nativeBase-ui/InputBase";
import Select from "../nativeBase-ui/Select";
import Text from "./TextFont";

type Props = {
  label?: string;
  helpText?: string;
  data: string[];
  valueSelect: string;
  valueInput: string;
  onChangeText: (value: string) => void;
  onChangeSelect: (value: string, index?: number, data?: any) => void;
};

const IntervalPicker = (props: Props) => {
  // === data example => ["value1","value2","value3",...]
  // === result selectValue => "value1"
  const {
    label,
    helpText,
    data,
    valueInput,
    valueSelect,
    onChangeText,
    onChangeSelect,
  } = props;
  return (
    <View style={{ marginVertical: 10 }}>
      {label && (
        <Text style={{ color: Theme.COLORS.MUTED, marginHorizontal: 3 }}>
          {label}
        </Text>
      )}
      <View
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Text style={{ marginEnd: 3, color: Theme.COLORS.MUTED, fontSize: 12 }}>
          {translate("timer.after")}
        </Text>
        <InputBase
          containerStyle={{ width: 100, marginHorizontal: 10 }}
          inputStyle={{ height: 40, textAlign: "left" }}
          keyboardType="numeric"
          onChangeText={(txt: string) => {
            onChangeText(txt);
          }}
          value={valueInput}
        />
        <View style={{ flex: 1, marginStart: 5 }}>
          <Select
            data={data.map((v: string) => {
              return { value: v, label: translate(`timer.${v}`) };
            })}
            value={valueSelect}
            onChangeText={(value: string, index: number, data: any) => {
              onChangeSelect(value, index, data);
            }}
          />
        </View>
      </View>
      {helpText && <Text style={{ fontSize: 12 }}>{helpText}</Text>}
    </View>
  );
};

export default IntervalPicker;
